module.exports = __webpack_public_path__ + "static/media/sohanlal.2182286c.svg";